import ViewportWmsImageLayer, {
    buildViewportImageTransform,
    lonLatBoundsToWebMercatorBbox,
    longitudeToWebMercatorX,
    latitudeToWebMercatorY,
    MAX_MERCATOR_LAT,
} from './ViewportWmsImageLayer';
import { sidusisAttribution } from './attribution';

export { lonLatBoundsToWebMercatorBbox };
export const buildSidusisImageTransform = buildViewportImageTransform;

export function buildSidusisPlaceUrl(latlng, mapZoom) {
    if (!latlng || !Number.isFinite(latlng.lat) || !Number.isFinite(latlng.lng)
        || Math.abs(latlng.lat) > MAX_MERCATOR_LAT || Math.abs(latlng.lng) > 180) return null;
    const url = new URL('https://internet.gov.pl/map/');
    url.searchParams.set('center', longitudeToWebMercatorX(latlng.lng) + ';' + latitudeToWebMercatorY(latlng.lat));
    // OpenLayers uses a 256px world; MapLibre uses 512px (one zoom level more).
    // The source map supports 18–21 for an address-level view.
    url.searchParams.set('zoom', String(Math.max(18, Math.min(21, Number.isFinite(mapZoom) ? mapZoom + 1 : 18))));
    return url.toString();
}

export function buildSidusisGetMapUrl(bounds, width, height) {
    const params = new URLSearchParams();
    params.set('SERVICE', 'WMS');
    params.set('REQUEST', 'GetMap');
    params.set('VERSION', '1.3.0');
    params.set('LAYERS', 'layers');
    params.set('STYLES', '');
    params.set('FORMAT', 'image/png');
    params.set('TRANSPARENT', 'true');
    params.set('CRS', 'EPSG:3857');
    params.set('WIDTH', String(Math.max(1, Math.round(width))));
    params.set('HEIGHT', String(Math.max(1, Math.round(height))));
    params.set('BBOX', lonLatBoundsToWebMercatorBbox(bounds).join(','));
    return SidusisLayer.WMS_URL + '?' + params.toString();
}

/**
 * SIDUSIS does not currently return Access-Control-Allow-Origin for GetMap;
 * see ViewportWmsImageLayer for the CORS-free viewport image.
 */
export default class SidusisLayer extends ViewportWmsImageLayer {
    static ID = 'sidusis';
    static DESCRIPTION = 'Dostępność internetu stacjonarnego';
    // Buildings: MaxScaleDenominator=54168; at MapLibre's 512px world,
    // zoom 12 is ~1:68247 and zoom 13 ~1:34124. Address points start at 17.
    static MIN_ZOOM = 13;
    static WMS_URL = 'https://internet.gov.pl/geoserver/public/wms';
    static IMAGE_DATA_ATTRIBUTE = 'data-sidusis-image';

    buildGetMapUrl(bounds, width, height) {
        return buildSidusisGetMapUrl(bounds, width, height);
    }

    getAttributionHtml() {
        return sidusisAttribution();
    }
}
